@if (expanded() && section().subheadingKey) {
    <div class="yllw-sidenav__subheading">{{ section().subheadingKey! | translate }}</div>
}
<ul class="yllw-sidenav__menu">
    @for (item of section().items; track item.id ?? item.labelKey) {
        <li class="yllw-sidenav__item">
            <app-sidenav-link [item]="item" [expanded]="expanded()" />
        </li>
    }
</ul>
